module.exports = __webpack_public_path__ + "img/42.d39ab5db.svg";